import { jsx } from "react/jsx-runtime";
import { Image, noop } from "@tldraw/editor";
import { createContext, useContext, useEffect } from "react";
const AssetUrlsContext = createContext(null);
function AssetUrlsProvider({ assetUrls, children }) {
  useEffect(() => {
    const preloaded = /* @__PURE__ */ new Set();
    for (const src of [...Object.values(assetUrls.icons), ...Object.values(assetUrls.embedIcons)]) {
      if (!src) continue;
      const resource = src.split("#")[0];
      if (preloaded.has(resource)) continue;
      preloaded.add(resource);
      const image = Image();
      image.crossOrigin = "anonymous";
      image.src = src;
      image.decode().catch(noop);
    }
  }, [assetUrls]);
  return /* @__PURE__ */ jsx(AssetUrlsContext.Provider, { value: assetUrls, children });
}
function useAssetUrls() {
  const assetUrls = useContext(AssetUrlsContext);
  if (!assetUrls) {
    throw new Error("useAssetUrls must be used within an AssetUrlsProvider");
  }
  return assetUrls;
}
export {
  AssetUrlsProvider,
  useAssetUrls
};
//# sourceMappingURL=asset-urls.mjs.map
